import { createAction } from '@reduxjs/toolkit';
export const FETCH_ANALYTIC_SUBSCRIPTION_USAGE = 'FETCH_ANALYTIC_SUBSCRIPTION_USAGE';
export const fetchAnalyticSubscriptionUsageAction = createAction(FETCH_ANALYTIC_SUBSCRIPTION_USAGE);